module.exports = __webpack_public_path__ + "static/Apercu-BoldItalic-2f656d9622a344b496c5e267d1605c88.woff2";